<div id="clients-container" class="container-fluid mt-5">
    <div class="row justify-content-center">    
      <div class="col-8 text-center text-white ">
        <h6 class="font-brand-secondary" style="display: inline; clear: none;">CONFÍAN </h6>
        <h6 class="font-brand-secondary text-brand" style="display: inline; clear: none;">EN NOSOTROS</h6>
      </div>
    </div>

    <div class="row justify-content-center g-0" style="margin-top: 79px;">
      <div class="col-10 px-0 text-center text-white ">
          <div class="row justify-content-center text-center g-0">
              <div class="col mx-2 px-0" *ngFor="let image of images1">
                <img class="img-fluid " src={{image.url}} alt="">
              </div>
          </div>
      </div>
    </div>
    <div class="row justify-content-center g-0 mt-3">
      <div class="col-10 px-0 text-center text-white ">
          <div class="row justify-content-center text-center g-0">
              <div class="col mx-2 px-0" *ngFor="let image of images2">
                <img class="img-fluid " src={{image.url}} alt="">
              </div>
          </div>
      </div>
    </div>
</div>    
